import React from "react";
import photo from "../../../assets/images/user4.jpg";
import { IMemberListData } from "../../../exports/interfaces";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";
import {
  getMembershipStatusColor,
  showRenewButton,
} from "../../../exports/functions";
import { useNavigate } from "react-router-dom";

const ProfileDetails = (props: { listMemberData: IMemberListData[] }) => {
  const mobile = useMobile();
  const tab = useTab();
  const navigate = useNavigate();
  const profilePicData =
    props.listMemberData[0]?.attributes?.Profile_Picture?.data;
  const { color } = getMembershipStatusColor(
    props.listMemberData[0]?.attributes?.Status
  );
  return (
    <section
      className="quality-work"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: !mobile && !tab ? "240px" : "unset",
      }}
    >
      <div className="container">
        <div
          className="section-title custom-text-center"
          style={{ marginBottom: "10px" }}
        >
          <h2 className="section-title__title custom-user-section-title">
            Dashboard
          </h2>
        </div>
        <div className="row">
          <div className="col-xl-7">
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two__single"
                style={{
                  padding: "0px",
                  backgroundColor: "transparent",
                  height: "auto",
                }}
              >
                <div className="user-card">
                  <div className="user-card__header">
                    <div className="user-card__image">
                      {profilePicData !== null &&
                      profilePicData !== undefined ? (
                        <img
                          src={`${process.env.REACT_APP_strapiUrl}${profilePicData.attributes.url}`}
                          alt="user"
                        />
                      ) : (
                        <img src={photo} alt="user" />
                      )}
                    </div>
                    <div className="user-card__info">
                      <h3>
                        {props?.listMemberData[0]?.attributes?.First_Name}
                      </h3>
                      <p className="user-card__designation">
                        {props?.listMemberData[0]?.attributes?.Designation}
                      </p>
                    </div>
                    <div className="user-card__status">
                      Status:{" "}
                      <div
                        className="statu-chip"
                        style={{
                          color: color,
                        }}
                      >
                        {props.listMemberData[0]?.attributes?.Status}
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="user-card__details">
                    <p>
                      <strong>Email:</strong>{" "}
                      <span>{props?.listMemberData[0]?.attributes?.Email}</span>
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      <span>
                        {props?.listMemberData[0]?.attributes?.Mobile_Number}
                      </span>
                    </p>
                    <p>
                      <strong>Address:</strong>{" "}
                      <span>{props?.listMemberData[0]?.attributes?.City}</span>
                    </p>
                    <p>
                      <strong>Qualifications:</strong>{" "}
                      <span>
                        {props?.listMemberData[0]?.attributes?.Qualifications}
                      </span>
                    </p>
                    <p>
                      <strong>Professional Affiliations:</strong>{" "}
                      <span>
                        {
                          props?.listMemberData[0]?.attributes
                            ?.Professional_Affiliations
                        }
                      </span>
                    </p>
                    <p>
                      <strong>Membership Expiry:</strong>{" "}
                      <span>
                        {
                          props?.listMemberData[0]?.attributes
                            ?.Membership_Expiry
                        }
                      </span>
                    </p>
                  </div>
                  {(showRenewButton(
                    props?.listMemberData[0]?.attributes?.Membership_Expiry
                  ) && props?.listMemberData[0]?.attributes?.Status !== "Pending")&& (
                    <div className="welcome-one__btn-box">
                      <span
                       onClick={() => {
                        navigate("/become-a-member", {
                          state: { memberData: props.listMemberData },
                        });
                        window.location.reload(); 
                      }}
                        className="thm-btn welcome-one__btn"
                        style={{ cursor: "pointer" }}
                      >
                        Renew
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-5"
            style={{ marginTop: mobile || tab ? "10px" : "unset" }}
          >
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two__single"
                style={{ padding: "0px", backgroundColor: "transparent" }}
              >
                <div className="admin-notice">
                  <h3 className="admin-notice__title">Admin Notice</h3>
                  <hr />
                  <div className="admin-notice__box">
                    <span>No notifications</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileDetails;
